enum TechnologyTemplateGroup {
    Competitor,
    Integration,
    MyTechnology,
}

export default TechnologyTemplateGroup;
